import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import SwapVertIcon from '@mui/icons-material/SwapVert';

const ReactionSort = ({ sortBy, handleSort }) => {
	const [show, setShow] = useState(false);
	const handleOpen = () => setShow(true);
	const handleClose = () => setShow(false);
	const sortOptions = [
		{
			key: 'videoAdded',
			label: 'Video Added',
			options: [
				{ value: 'video_newest', label: 'Newest Video First' },
				{ value: 'video_oldest', label: 'Oldest Video First' }
			]
		},
		{
			key: 'dateAdded',
			label: 'Reaction Date',
			options: [
				{ value: 'newest', label: 'Newest First' },
				{ value: 'oldest', label: 'Oldest First' }
			]
		},
		{
			key: 'title',
			label: 'Title',
			options: [
				{ value: 'title_asc', label: 'Title (A-Z)' },
				{ value: 'title_desc', label: 'Title (Z-A)' }
			]
		},
		{
			key: 'instructor',
			label: 'Instructor',
			options: [
				{ value: 'instructor_asc', label: 'Instructor (A-Z)' },
				{ value: 'instructor_desc', label: 'Instructor (Z-A)' }
			]
		},
		{
			key: 'likes',
			label: 'Likes',
			options: [
				{ value: 'likes_asc', label: 'Least Liked' },
				{ value: 'likes_desc', label: 'Most Liked' }
			]
		},
		{
			key: 'dislikes',
			label: 'Dislikes',
			options: [
				{ value: 'dislikes_asc', label: 'Least Disliked' },
				{ value: 'dislikes_desc', label: 'Most Disliked' }
			]
		}
	];

	const handleChange = event => {
		handleSort(event.target.value);
	};

	return (
		<>
			<Button variant="outline-primary" className="d-flex align-items-center gap-1" onClick={handleOpen}>
				<SwapVertIcon color="#3CB4E4" />
				<span className="sr-only">Sort by</span>
			</Button>
			<Modal show={show} onHide={handleClose} centered>
				<Modal.Header closeButton>
					<Modal.Title>Sort By</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Select className="filterby" value={sortBy} onChange={handleChange}>
						{sortOptions.map(optgroup => (
							<optgroup key={optgroup.label} label={optgroup.label}>
								{optgroup.options.map(option => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
							</optgroup>
						))}
					</Form.Select>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default ReactionSort;
